<script>
    export default {
        name: "RecipeDetailText",
        props: {
            title: String,
            text: String,
        },
    };
</script>

<template>
    <div class="recipe-detail-text recipe-detail__section">
        <div class="recipe-detail-text__title">{{ title }}</div>
        <div class="recipe-detail-text__description" v-html="text"></div>
    </div>
</template>

<style lang="scss">
    .recipe-detail-text {
        padding: 24px 24px 32px;
        @include bp($bp-desktop-sm) {
            padding: 40px 40px 48px;
        }
    }

    .recipe-detail-text__title {
        margin-bottom: 12px;
        color: #0b0b0b;
        font-size: 18px;
        font-weight: 700;
        line-height: 22px;
        @include bp($bp-desktop-sm) {
            margin-bottom: 24px;
            font-size: 22px;
            line-height: 30px;
        }
    }

    .recipe-detail-text__description {
        color: #2e2e2e;
        font-size: 14px;
        line-height: 24px;
        @include bp($bp-desktop-sm) {
            font-size: 16px;
            line-height: 32px;
        }

        blockquote {
            margin-bottom: 20px;
            padding: 0 20px;
            font-style: italic;
            border-left: 2px solid #000;
        }

        ol {
            counter-reset: number;
            list-style: none;
            li {
                position: relative;
                padding-left: 20px;
                @include bp($bp-desktop-sm) {
                    padding-left: 44px;
                    max-width: 880px;
                }
                &:not(:last-child) {
                    margin-bottom: 16px;
                    @include bp($bp-desktop-sm) {
                        margin-bottom: 24px;
                    }
                }
                &::before {
                    content: counter(number);
                    counter-increment: number;
                    position: absolute;
                    top: 0;
                    left: -12px;
                    display: block;
                    @include box(24px);
                    font-size: 12px;
                    font-weight: 500;
                    line-height: 20px;
                    text-align: center;
                    border: 2px solid #0b0b0b;
                    border-radius: 50%;
                    @include bp($bp-desktop-sm) {
                        left: 0;
                        @include box(32px);
                        font-size: 14px;
                        line-height: 28px;
                    }
                }
            }
        }

        ul {
            li {
                position: relative;
                @include bp($bp-desktop-sm) {
                    padding-left: 14px;
                    max-width: 854px;
                }
                &:not(:last-child) {
                    margin-bottom: 16px;
                }
                &::before {
                    content: "";
                    position: absolute;
                    top: 9px;
                    left: -12px;
                    display: block;
                    width: 6px;
                    height: 6px;
                    border-radius: 50%;
                    background-color: #0b0b0b;
                    @include bp($bp-desktop-sm) {
                        top: 13px;
                        left: 0;
                    }
                }
            }
        }

        p,
        ol,
        ul {
            &:not(:last-child) {
                margin-bottom: 8px;
                @include bp($bp-desktop-sm) {
                    margin-bottom: 12px;
                }
            }
        }
    }
</style>
